import {SELECT_PRODUCT} from "../types";

export function selectProduct(productId) {
    return function (dispatch) {
        return dispatch({type: SELECT_PRODUCT, productId})
    }
}
